export const ROUTE_PATHS = {
  AUTH: {
    LOGIN: "/login",
  },
  DASHBOARD: "/dashboard",
  SCHEDULE: {
    LIST: "/schedules",
    DETAIL: "/schedule/:scheduleId/details",
  },
  CLASS: {
    LIST: "/classes",
    DETAILS: "/class/:classId/details",
    SCHEDULES: "/class/:classId/class-schedules",
  },
  BOOKING: {
    TRAINER: {
      LIST: "/trainers/pt",
      DETAIL: "/trainer/details/:id",
      SCHEDULES: "/trainer-schedules/:id/service/:serviceId",
      PROGRAMS: "/trainer/programs/:id",
    },
  },
  FACILITIES: {
    LIST: "/facilities",
    DETAIL: "/facility/:facilityId",
    BOOKING: "/facility/:facilityId/booking",
  },
  MYBOOKING: {
    LIST: "/my-bookings",
  },
  MEMBER: {
    INFORMATION: "/member",
    // Tab values for the member profile page, deep-linkable via `/member?tab=`
    TABS: {
      INFORMATION: "1",
      GOAL_SETTINGS: "2",
      UPLOADED_DOCUMENTS: "3",
      FEEDBACK: "4",
    },
    POINT: "/member-points",
    PAY_WITH_QR: "/member-pay-with-qr",
    GOAL_SETTING_DETAIL: "/goal-setting/:id/details",
    GOAL_SETTING_MORE_DETAIL: "/goal-setting/:id/more-details",
    GOAL_SETTING_TRAINNING_INFO: "/goal-setting/:id/training-info",
  },
};
